import { useTranslation } from 'react-i18next';
import { Brain, Database, TrendingUp } from 'lucide-react';

export function SolutionPillarsSection() {
  const { t } = useTranslation();

  const pillars = [
    {
      icon: Brain,
      title: t('landing.solution.pillar1Title'),
      desc: t('landing.solution.pillar1Desc'),
    },
    {
      icon: Database,
      title: t('landing.solution.pillar2Title'),
      desc: t('landing.solution.pillar2Desc'),
    },
    {
      icon: TrendingUp,
      title: t('landing.solution.pillar3Title'),
      desc: t('landing.solution.pillar3Desc'),
    },
  ];

  return (
    <section className="py-20" style={{ background: 'linear-gradient(180deg, #1A1F3C 0%, #0F1828 100%)' }}>
      <div className="container">
        <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-white md:text-4xl">
          {t('landing.solution.headline')}
        </h2>

        <div className="mx-auto max-w-5xl grid gap-6 md:grid-cols-3">
          {pillars.map((pillar, i) => (
            <div key={i} className="rounded-xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-[#4F6CFF]/20">
                <pillar.icon className="h-6 w-6 text-[#4F6CFF]" />
              </div>
              <h3 className="mb-3 text-lg font-semibold text-white">{pillar.title}</h3>
              <p className="text-sm leading-relaxed text-white/60">{pillar.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
